
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexmsYHe_RohYpRlEuVKlxSMc1EVw_p4T5jObqrsxxbYuwMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/index.vue?macro=true";
import { default as loginyQnfR3wAnt2TFhAw6E_XKIxSD1F5WG9QeBoFFnaxAXIMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/login.vue?macro=true";
import { default as _91key_93_NLrfE7zLEOGV_45toEoPDUD8lGKukRvb6Jx_P02i3d1QMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/s/[key].vue?macro=true";
import { default as mgenWJoeo6tCrGHVdPNkIEp94QjplS6Bu9GygAEgx9J4u24Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/mgen.vue?macro=true";
import { default as indexxTH6v3bbdTzYx_CtVqLXisTWUqHB73kbDYQ7PQK7HaIMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/index.vue?macro=true";
import { default as notesObuT276YTiEVIWUbVPkr8XRIEtKrxmrDhFVqd1Q7dbwMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/notes.vue?macro=true";
import { default as indexYOBJuqF4kKflWfILph6LF8OUM8sPMTIzpNliiWJpjjMMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentn8VEo9kcvyTX1GHmSvB7DkB8w7njCQ9CEOSvmeuz7K4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45site5_1q0jkflAjOvIe1dU3_45ceZkL0RcnC1Wkru220Fyb20Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/plan-du-site.vue?macro=true";
import { default as edit0Rav7habmC5m_ALIk5cHnLVwoGJqhLL3Nl7NrvCyjP4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/edit.vue?macro=true";
import { default as placesZqQ3Dkmk_451LK9ndRxvpLef9EPdqQ2He55eT2nI4_BPoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/places.vue?macro=true";
import { default as accessibilite3Aqrt_T7CwkMAhfrInNCweLC5X88sSuqhVKt9ZOZLbEMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/accessibilite.vue?macro=true";
import { default as _91id_93O_iFw7zCzcsWwQzSUmSV2A57yyaKNyNh8_452Tmwv0UKEMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/messages/[id].vue?macro=true";
import { default as notificationsV_45zMhKXDZGtj5bwZVqsdBfAteibQW3EZcxg5G7hOG4EMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/notifications.vue?macro=true";
import { default as indexSlNk6P5MgyQH_45qGv4RIbwfocIVuvLNLmJI_g5aKV_R0Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/index.vue?macro=true";
import { default as indexuvodAs03Yevee53LbE0PNDKJ_45EZMmUBoaX_21g4N6iYMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/index.vue?macro=true";
import { default as _91slug_932LBQeZQTvl84BAX9hbvbvydWXLaIsF96aHRJ45deTGQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/villes/[slug].vue?macro=true";
import { default as indexEQLrobiR3P3r34SvTKrGqvA8UMvJANGJLnPyYEwlnvQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/messages/index.vue?macro=true";
import { default as generiqueR7dPuCm9i_oX43KgkTEoc9iSDjDYLJ4FiOle0JPWImEMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93mzBgA8PQH1d6dyqRFIWGee0PZlKD5_YkT7PTIaI59BYMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/reseaux/[slug].vue?macro=true";
import { default as missions_ONuy7A2TAQvilvBmeYMk0Z7lnXYaiqp68apirMMo4UMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/missions.vue?macro=true";
import { default as index9lg45bvuaP4SeOyp1dVvD5A72zSqr1kfA6bxKS1IktoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/dashboard/index.vue?macro=true";
import { default as favorisLaO44x8B5g7evZdUlIZ_vmFhVCezS_45dOZjNI_xsHk_45cMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93U_45wfZ1OzXY4wJyf6ulJVa8yFa8_45cR_45WYrR1YgjDJO3EMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/activites/[slug].vue?macro=true";
import { default as logsWUExQYQ_zSCeMTy7ublsUPxI2n3iGztinaQmA4lcE14Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/other/logs.vue?macro=true";
import { default as ressources1tyx_eFA_45t3LtXtdrNlHaZLNHRneSG6uM5_znZNjAFgMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesmicBRkxEACN2fvC4b8orzmPCitx7hIWCj_BQxLYQ7s0Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/mentions-legales.vue?macro=true";
import { default as missionshEOARj4_45_45BfzPPmaltlxLD2I7pffGLG_45pKPRjewHaS4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/missions.vue?macro=true";
import { default as settingsp3eTRrLt8aWDesUMPlCtljWdwrAWgMJkzspEKHKqEbkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/settings.vue?macro=true";
import { default as tournee_45eteSx3_457F9Q1MlucMQS6uUOW1wTelicTIE4Tqm4iP1IyQ4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignagesLpYalbnctuSg45IVLPfs4IC0JzyoBGrgQPf1QVamAdQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/temoignages.vue?macro=true";
import { default as indexugB3zUYCdCZrUJjcyYLc10GUvgFBCGmXox8QtzmJ4XYMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/index.vue?macro=true";
import { default as adminVwEGmEtGYUHw36cuip_45_3xiqcp2wexkVE4mUtNGIJIoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/maintenance/admin.vue?macro=true";
import { default as indexULzKgsfvy00DfImmQHDqv2HMSLQJjxRqXKBBMUxp5BoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/maintenance/index.vue?macro=true";
import { default as indexK2wQG4kY4nvGd4mdlFUUvvtP6qtkW2bxa9GYS74zXKkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/territoires/index.vue?macro=true";
import { default as _91hash_938UsuvbThgjnnNnWQ26RjRVgWHuXqVltyqFqphfe1MYkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/invitations/[hash].vue?macro=true";
import { default as utilisateurs3nv9cLTZZdJ0yOj8Odx90I6DhRnBiEbFmRjgk5_zuNkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93G2gUHgqgUOmER0qtRcWtPu9b66oUkVTokU2_45sEmAhLUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93JlywkhZ2APafdVmLiJHgV6z8ap1p0F9jEj8kM7NlsZsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/departements/[slug].vue?macro=true";
import { default as index5tfSN2A7foqbILxI_45g0Kl2i2UG9WZmIXLYslX_fRwpcMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/organisations/index.vue?macro=true";
import { default as preferencespqKwhPlTwcmdB_E2eY8c_45LaMzIfkqlZYXkmCAgM680EMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/preferences.vue?macro=true";
import { default as organisationsDsRPhhpTaCwmauaYb6wLYGmmeJ1MWji4LvfccoLaRlcMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/organisations.vue?macro=true";
import { default as _91token_93cLDxulBasRp0Xfx6JhKYgdbBUQmuzj40LQ9Xh8A2zicMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/temoignages/[token].vue?macro=true";
import { default as postsJL2AzCuiOQQP9xY8UuK5pr7XkalzeQFNix3hmHaRO_450Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/posts.vue?macro=true";
import { default as indexGeW_xT6_TI8xMkSZrZ6Eh4hyldHVANiML3tnliZalFwMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/index.vue?macro=true";
import { default as addqkjldE6uvwLIWJLd__45w7CCW55qvGfQPHwiGkDQf1rCMMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93oCOZtTTwYYl_45z6Q7x2f_UBofUNf41Epq0rp2aqxMH18Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/organisations/[slug].vue?macro=true";
import { default as index_hMPZIoNEER196X5GXUuOGcPCGDusozmHSkL8F24mfQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/password-reset/index.vue?macro=true";
import { default as participationskIswwbLlMGNz6wc_45qpI_VOdopDAY8bKT8FLRjygcHSoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/participations.vue?macro=true";
import { default as emailsW4jGy_jW_45hdQCvwbAMpieICysaEwBvpl7K1aWIRgTewMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/emails.vue?macro=true";
import { default as indexJfdZ46DJttPJuKY9T2jGnOv1dBCw_oxJfaELHmlgDrsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/alertes/index.vue?macro=true";
import { default as notifications74sRKhNc47AhKLPWqR7VKMfha7YNc0ku36iZVTkA7hUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/notifications.vue?macro=true";
import { default as indexhrTSwXnXsUENb48PF8UrcQ4Gdeuqo5xQLhayeXGhm_45wMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civique2KhIrsYRb8KCQpav5ZsADLGJWSsCceLVrO2__45LjhCu8Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93TKdG52NmqT43gRBCPGMIIAYDSc_tm4M9pBt_TlU9tD8Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/domaines-action/[slug].vue?macro=true";
import { default as indexLR3hNg9oL2nZ0nyVSNNsxevzoiBJ1dbzicFnUIC4xmUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93MjaSsrgw1Wzh_450Lpqq01yoG3GYaSsCELI05SnG5SYswMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensembleGOH_2x8Oo_45iU9Q53WofpuU2byARZat44r77jNvFEZswMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsjZqBBi_qjvlNqsxagyqBMV2RPrlV_1rhoRgrAIxPhPwMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/other/invitations.vue?macro=true";
import { default as messages_AHUNKqBxEAyPGA2PO0EIFpI_45fQBb7q9jZ_sajVNsFsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/messages.vue?macro=true";
import { default as placesdMp9m71SihRMsMt1wuk4vEkwJVKGFvgrK6x_45DiEiFpcMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/places.vue?macro=true";
import { default as addFE7d2Dsyj5R4j8MFYdGCfDLk0c9TF3_mx_45J8Lawr_45NEMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexy80mLhzwa276J4f37WNtjSZLV4dhtzrRXawTF21OsRsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indextncSZ_v_QNBOHB0ZLNvHWsjvKKvg3F2kQxFZPS_Vz7YMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/missions-benevolat/index.vue?macro=true";
import { default as dates_epxFyJe3h6mCHEzkU21MIen0LFoRqX6v1fSBwHtzf0Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexwrSlfb8DzcIITJg_lIFxOtRAV5rFghl_45TIFM2aL_44sMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxNSFOmwyU_45xMRhwZiauqtXl_zqP97agu_UT3S6mg250IMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as title87TIDsi1_45xwJnFnh5Untxlct9LK5zPs4GU7Z1zWLtIUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexnD3k6X5ZiEVYTNf5cSPUkSaJeYgNunSWOCMhWaR1rBYMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/index.vue?macro=true";
import { default as missionscvJbKn6AksXnPJmcSo7IPmEAY7caDXkyR9XYNXTAdgoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/missions.vue?macro=true";
import { default as add3kqPCZjtAo4g_45Ez6GhItMZJa6NcU4XfVf_45HSUb_guugMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelKGwe7IgAcMpvC_kUwFNp_45Mh9zw3IRvv8PKvFzjMxTjcMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexq5qnW9cGzokBGF_ErXt_455cf678eS9KWL8c0pdQXF0U4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/participations/index.vue?macro=true";
import { default as indexvwPDUx5_rOS7ZedpeP5vouEEM_A02U_AKdPs7l4CiG0Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexWocHbrQd1alb7iNog1BGSUFLhivK3GwZUTi0jEjhsZYMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/index.vue?macro=true";
import { default as addP5b_tz9Tt8ZVk6mADqO4DF5kEXbbOQtLAWk9abJ7mLUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addVIrnk5TYT20UhbJZrGkIEtwYwbuqGwqGzvXojGT5Cr4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addD5gpg0XFV67MH_KcG_45iQgsWWLp4wcNzp9paApikw8EQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexGN7N80HE1sO2T63yB1TsibNz_45Mg7_45P5q0eDhz5TfFUkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsOX1bZnwGqJ0eNjVnuS49I3SdBCShxvnyCUCZxbCcbPgMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/conversions.vue?macro=true";
import { default as editbSM1R1JdUFlCBP60f72efpgRGF81tpTkncUImwJhVokMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialite8ORxDbGz7h1riU598I7iVADcYkZ9kaj0P8uPtmC93qYMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexiSgLlxgWYOmDjrnFQCuKoG2QgcKaKqpulsuO6Q6Xb80Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addKw9vnzrK26jr0MtTrafILM3Og6DfwN4azg7f31_O6ZQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesc_45EgOMGNAvq_45NUn2KjJ5hkIEIGPZXSeC2SP7RP_45g2VQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editsiSfh9CLA_0sl2Hddo_4584n_45t461GEkKaa13OHvYbGX4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateurs_phqlgs09nq5AlEFCUyTBGBzIUiyAbHRl7CgZIdoCYQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexsyMqmK8rAluHuX7tDqirwnlteqGAwm0dUVR_45tNedCJsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexnsE2CMLWd0m_BpDyyhYoHHLTUWcfCOHI6fTTa25YhIoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as index7o359QDYt_KQQKOjR2exhvLwbRUfzsPO0LyDjYZKS6AMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/index.vue?macro=true";
import { default as indexjSfFh59O83W09eNLGVvJZ_DmB_456Zh_45SKQRwfCabLWCsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendreDwU6F9jwjvOx9FIET3UP1Jb2HGiqfs8XRB3hYL56EpUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexBF8onzAFclDu3n_45MVfS8HrN_45mTgOpHNe5YUmsXRoqzQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addAiunKgofavB_45VblJFKwYS8H8UyZTmhTpULsOtsNC7NoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as index0n_45PzcNAFmIg_IgbtDOpJMhLNbibiAjIkEq1sS5pQIoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editbccHhQs4UybQJo2q4O1hMDpygOZAr2wRkPcorU6DlrMMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93UqA4yPo09SCRAJAnqF3Ht_45Dqxz9OPFjbkkmS1xC_45LpIMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteudu97VRzYD2A9vA7fIaYtdU8RQxkYx3Npct0T7YuU3IMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexmo5hwgOWl4z1OcLqRsZqFF4qjjQ6oI8YIlRQ6B5bUwcMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsh_45ZCuzYLyTEYCqOcdglr8JRrhCYL49z9GDXCizEzuz8Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/participations.vue?macro=true";
import { default as indexgsdsNrp_45B7ZM6gSRHiPV8A4VHY3Wxl1vr7GEGAHBBPIMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsCNQgy_45q_45VhA5yzXoWLoXj3ANr1lWfRWTvovWmFNfRxkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/referents/activity-logs.vue?macro=true";
import { default as edit5bnHwVu048ngKmuKsAy2kaNOpopgi61bynsTnsdCQ7wMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexi6nF1MLTXCc1aUE3URSYsviT03nRxkXbrTiO2SMr9LEMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsAk4_Nr9C236Hs5HlinVpIpipSmglesVzKvE2whQYcqsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesrg6N_k_45txi8HbtdC8cLQCbG8K1VyeffQLSb7LaYCvlkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editdnpW2JXIwDhexzkO7k4EjiTLoyVLwzyWjYAUFac2tDwMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexPuX5_45cBUFG7pxDyDXirU29WRiT_45VbGmEaEdSsp5EEroMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexqO_45aZJk26RbeIXrDdbqIYEfM6fWSGbmcr_45Uq7zkqdW4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45cles7Q2AA4poD81QKjRdpLzoIeGLUj_45leDaBe5ZM41XD0ekMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editSjHXkaFXydbV4XT4Dn2ss_e_MjMrSnwpeKiQ_45UgjHrEMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profileY_QI5kn0wi6N89OWjWkN8NHo3FRDVPnJKYanxBVaM6sMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementnywvJ91KIPNBLdjhSz2uaZ7WYiF82k4IdYC96qKhKicMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsovaEi26zVqkHnacdJJ_0g6bmPKpDIbO9UfycK8knGPcMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/referents/waiting-actions.vue?macro=true";
import { default as edit_6bde8p8Wjg2NTTzkN0DbGctX9XQU78uH_G8cvz_DykMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addzxzRSObHxj1ceQysOcSVH6NOdQVAHmO20oF_45OiIbxPwMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationKMLDOOZxGNgNtAgNt45jr7AieDhS_YzMo1wh7i_45aQQ4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexEo0NniKKSKFld0n_rp1kSV2ZePiGfU5_lRvv4oFvgVQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as edit1EB7Z6p5BTcCMWMtpvTsx_nK9T9E59vkfnEeWYLznf0Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusions9GI1yjfSkEbE7f5hJ4EUbli3EWSXyzQ1c7WfWi13P_wMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsnHmZxN2CgtU3SGOej9ZBtIB9DYh7Md8qwvVR1nBJPIIMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesoFqIG4K1v5atmLrGp6fDhlmnZ4iy7PvbAxk4E_HaWkkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingMtcO4tbemllD2AY0fRve6AVQOzDRxopCFxM796noPC8Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexPiiwsuQIMaUac7ygHmdTW8XNb7at2XSMhw_qaI83U_4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as edit_B8oTyQUMV_45JnnxjJkTUzn2FmgM_455cNmFvmTvwbq_9oMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexZ8HH5hwFB0lbT_45nnpSjq_45g3i8hRz9DipJ1Ot4l3cpF0Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profileOvdXmhhQn6UzAJojThaIL99B9X4IXMI8b_ehIUDlQJAMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as index1KcOOE18lbPHzz7nu42GsJFKsxy3ItSnEYrOZvdjWnMMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as edit8pK0J5FaFoCQPEj75N9KPzKckEppL7oCkNLAydImj7MMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addCtgO_jmTZrADOS6viBZlCrenLbjgs5dwLJOLgmKOY0EMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesGzpsazCwLbbvHqaW2Gdb57oRmhxrzIxqdTXbnTrG8h4Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesl6_45_45IHN1bYIbKUg_45hxZE6UE_45__XW4FsfNzs_7IgjfaAMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45users1J88SWz19ZTnWvt4PsTcWjuTx1OUExmk4bbzGS3mnroMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresBK4yBt_45wSUHyjJVQHJhnlSp0Uw_SwS0jRFH4KGUA2uMMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablescRj_M7kFqy29wJ83R_45GD06Hi_sp_45g8AQK_45oVGCvqUxQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisation00_PfnQPvRhBm9lwOsCc0Zk4ANQ7sisIGzigz_mPtNcMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedBvqKf4pXo1lgFe6g0DgExdsu2ZwgCraVN1EZzOrsWXIMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsJNtL4Yjehmu6Tkqx74Osa9sZtknew1rJ_kDGABr6mb0Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45role2eOafReBBVEh7afkb0a2keO2M4FqSAbNeOCPyC2iymUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsHG17Z3zwN69vtHjDhfHx4V07vUOZG6z7qoPZ7gV2z84Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editWUsZ98m2KsB_454Tq8LHIslt_45gB5Te_45rv_ZN4N16vXSSwMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibiliteskhyZqJKwTH7OwbV_pPvhYJS_45kMWjLDK3VbuoIwksn68Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45link2RuhllH8K_45o74jTKipTdJpJ6cc6ExRrRgXjp6iAwRfQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexN_45c47_45c2GTqxnmVrK_Xyys3E9VTxcYK7Mur43StJAWgMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivite8nAFyfNkxX8fJorseN_D12fjeX5vz82S0Qz0wh5TlmkMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationQtmlIndEQnZH5qEFXCCYSVycypYPzziyugnvkIPnQLsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationszqqCc6JhE7zD450pP_45qXfj9oZuJe6z2R9tDl_DYxenUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantr4Q1LN7mh9PcRYBN7mm9UUpIiRqIW5UlVN0SPEDsn08Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantCSMxXaGx2G_XuFsvtbSRDt6bYae23CgW0rKDJMY36aEMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as index31Sc0_45cmJdhtWC7w82XUHUEgpRx6A03pBT_HMvAkmdsMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimees94sISIJOqOIW8dzxjS9YxPNAg30pyMJ8dbYeAJZlWMwMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerGoIpicD0xK6Kue7cE4DygRvEeTlce75noOHm7_IbSDcMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesOlyZjLhiE35hmfAooSbQE7BmNIjBeXnRo1cDKBqGwOQMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesvKH19X9ErKCK_45cQKAGd9l8pkBHKI4EvkIKaMgRdVkh8Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsXKGptq5V8a36P_45d_45X_45zBXFV6NlvuiNUu93cXeG6Py5UMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedOjt_FnqkVDewdbZyGtBn_4542aAt0b_45blX4Rqxh3oS3T8Meta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectkwhddQ5Wet_nhjTP5yhL0xqm2kOdXjT9qxetOBhzC_MMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validerZ5FkxV2jWclxCVAU6llJ2N7FASyDwoFMuU5TO0FQ5VoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnement5XjrrKoPpFSqDGPrW_45JiaPwdhj6YBvnL3M8sSEIynnoMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationHeUKyftz5VK_ypZwZAJAR6oiTCpNH1NWW1UkBoZcdcIMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationeLVGAXU1yfiYqKQQbkmbr94OyuQcuhRSlMeNE063gLUMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45valider_ETUwm8pGy02_LGgnJZeUOzmk2OgFKUBa1YWhQivt_QMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesePW8gsXxdEXe5FHkQXf3zfSfZ8JpNJDDaACPh4WT_aAMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta } from "/build/93859e61-d930-459f-b49a-be273e8bda22/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY } from "/build/93859e61-d930-459f-b49a-be273e8bda22/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginyQnfR3wAnt2TFhAw6E_XKIxSD1F5WG9QeBoFFnaxAXIMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/login.vue")
  },
  {
    name: "s-key",
    path: "/s/:key()",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/s/[key].vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenWJoeo6tCrGHVdPNkIEp94QjplS6Bu9GygAEgx9J4u24Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexxTH6v3bbdTzYx_CtVqLXisTWUqHB73kbDYQ7PQK7HaIMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesObuT276YTiEVIWUbVPkr8XRIEtKrxmrDhFVqd1Q7dbwMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexYOBJuqF4kKflWfILph6LF8OUM8sPMTIzpNliiWJpjjMMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: edit0Rav7habmC5m_ALIk5cHnLVwoGJqhLL3Nl7NrvCyjP4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesZqQ3Dkmk_451LK9ndRxvpLef9EPdqQ2He55eT2nI4_BPoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93O_iFw7zCzcsWwQzSUmSV2A57yyaKNyNh8_452Tmwv0UKEMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsV_45zMhKXDZGtj5bwZVqsdBfAteibQW3EZcxg5G7hOG4EMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexSlNk6P5MgyQH_45qGv4RIbwfocIVuvLNLmJI_g5aKV_R0Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexuvodAs03Yevee53LbE0PNDKJ_45EZMmUBoaX_21g4N6iYMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexEQLrobiR3P3r34SvTKrGqvA8UMvJANGJLnPyYEwlnvQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueR7dPuCm9i_oX43KgkTEoc9iSDjDYLJ4FiOle0JPWImEMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93mzBgA8PQH1d6dyqRFIWGee0PZlKD5_YkT7PTIaI59BYMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missions_ONuy7A2TAQvilvBmeYMk0Z7lnXYaiqp68apirMMo4UMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: index9lg45bvuaP4SeOyp1dVvD5A72zSqr1kfA6bxKS1IktoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisLaO44x8B5g7evZdUlIZ_vmFhVCezS_45dOZjNI_xsHk_45cMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsWUExQYQ_zSCeMTy7ublsUPxI2n3iGztinaQmA4lcE14Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionshEOARj4_45_45BfzPPmaltlxLD2I7pffGLG_45pKPRjewHaS4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsp3eTRrLt8aWDesUMPlCtljWdwrAWgMJkzspEKHKqEbkMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45eteSx3_457F9Q1MlucMQS6uUOW1wTelicTIE4Tqm4iP1IyQ4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexugB3zUYCdCZrUJjcyYLc10GUvgFBCGmXox8QtzmJ4XYMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminVwEGmEtGYUHw36cuip_45_3xiqcp2wexkVE4mUtNGIJIoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexULzKgsfvy00DfImmQHDqv2HMSLQJjxRqXKBBMUxp5BoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_938UsuvbThgjnnNnWQ26RjRVgWHuXqVltyqFqphfe1MYkMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateurs3nv9cLTZZdJ0yOj8Odx90I6DhRnBiEbFmRjgk5_zuNkMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencespqKwhPlTwcmdB_E2eY8c_45LaMzIfkqlZYXkmCAgM680EMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsDsRPhhpTaCwmauaYb6wLYGmmeJ1MWji4LvfccoLaRlcMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93cLDxulBasRp0Xfx6JhKYgdbBUQmuzj40LQ9Xh8A2zicMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsJL2AzCuiOQQP9xY8UuK5pr7XkalzeQFNix3hmHaRO_450Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexGeW_xT6_TI8xMkSZrZ6Eh4hyldHVANiML3tnliZalFwMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addqkjldE6uvwLIWJLd__45w7CCW55qvGfQPHwiGkDQf1rCMMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93oCOZtTTwYYl_45z6Q7x2f_UBofUNf41Epq0rp2aqxMH18Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: index_hMPZIoNEER196X5GXUuOGcPCGDusozmHSkL8F24mfQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationskIswwbLlMGNz6wc_45qpI_VOdopDAY8bKT8FLRjygcHSoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsW4jGy_jW_45hdQCvwbAMpieICysaEwBvpl7K1aWIRgTewMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexJfdZ46DJttPJuKY9T2jGnOv1dBCw_oxJfaELHmlgDrsMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notifications74sRKhNc47AhKLPWqR7VKMfha7YNc0ku36iZVTkA7hUMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexhrTSwXnXsUENb48PF8UrcQ4Gdeuqo5xQLhayeXGhm_45wMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexLR3hNg9oL2nZ0nyVSNNsxevzoiBJ1dbzicFnUIC4xmUMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93MjaSsrgw1Wzh_450Lpqq01yoG3GYaSsCELI05SnG5SYswMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembleGOH_2x8Oo_45iU9Q53WofpuU2byARZat44r77jNvFEZswMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsjZqBBi_qjvlNqsxagyqBMV2RPrlV_1rhoRgrAIxPhPwMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messages_AHUNKqBxEAyPGA2PO0EIFpI_45fQBb7q9jZ_sajVNsFsMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesdMp9m71SihRMsMt1wuk4vEkwJVKGFvgrK6x_45DiEiFpcMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addFE7d2Dsyj5R4j8MFYdGCfDLk0c9TF3_mx_45J8Lawr_45NEMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexy80mLhzwa276J4f37WNtjSZLV4dhtzrRXawTF21OsRsMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indextncSZ_v_QNBOHB0ZLNvHWsjvKKvg3F2kQxFZPS_Vz7YMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: dates_epxFyJe3h6mCHEzkU21MIen0LFoRqX6v1fSBwHtzf0Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexwrSlfb8DzcIITJg_lIFxOtRAV5rFghl_45TIFM2aL_44sMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxNSFOmwyU_45xMRhwZiauqtXl_zqP97agu_UT3S6mg250IMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: title87TIDsi1_45xwJnFnh5Untxlct9LK5zPs4GU7Z1zWLtIUMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexnD3k6X5ZiEVYTNf5cSPUkSaJeYgNunSWOCMhWaR1rBYMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionscvJbKn6AksXnPJmcSo7IPmEAY7caDXkyR9XYNXTAdgoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: add3kqPCZjtAo4g_45Ez6GhItMZJa6NcU4XfVf_45HSUb_guugMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelKGwe7IgAcMpvC_kUwFNp_45Mh9zw3IRvv8PKvFzjMxTjcMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexq5qnW9cGzokBGF_ErXt_455cf678eS9KWL8c0pdQXF0U4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexvwPDUx5_rOS7ZedpeP5vouEEM_A02U_AKdPs7l4CiG0Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexWocHbrQd1alb7iNog1BGSUFLhivK3GwZUTi0jEjhsZYMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addP5b_tz9Tt8ZVk6mADqO4DF5kEXbbOQtLAWk9abJ7mLUMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addVIrnk5TYT20UhbJZrGkIEtwYwbuqGwqGzvXojGT5Cr4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addD5gpg0XFV67MH_KcG_45iQgsWWLp4wcNzp9paApikw8EQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexGN7N80HE1sO2T63yB1TsibNz_45Mg7_45P5q0eDhz5TfFUkMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsOX1bZnwGqJ0eNjVnuS49I3SdBCShxvnyCUCZxbCcbPgMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editbSM1R1JdUFlCBP60f72efpgRGF81tpTkncUImwJhVokMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexiSgLlxgWYOmDjrnFQCuKoG2QgcKaKqpulsuO6Q6Xb80Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addKw9vnzrK26jr0MtTrafILM3Og6DfwN4azg7f31_O6ZQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesc_45EgOMGNAvq_45NUn2KjJ5hkIEIGPZXSeC2SP7RP_45g2VQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editsiSfh9CLA_0sl2Hddo_4584n_45t461GEkKaa13OHvYbGX4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateurs_phqlgs09nq5AlEFCUyTBGBzIUiyAbHRl7CgZIdoCYQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexsyMqmK8rAluHuX7tDqirwnlteqGAwm0dUVR_45tNedCJsMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexnsE2CMLWd0m_BpDyyhYoHHLTUWcfCOHI6fTTa25YhIoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendreDwU6F9jwjvOx9FIET3UP1Jb2HGiqfs8XRB3hYL56EpUMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexBF8onzAFclDu3n_45MVfS8HrN_45mTgOpHNe5YUmsXRoqzQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addAiunKgofavB_45VblJFKwYS8H8UyZTmhTpULsOtsNC7NoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: index0n_45PzcNAFmIg_IgbtDOpJMhLNbibiAjIkEq1sS5pQIoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editbccHhQs4UybQJo2q4O1hMDpygOZAr2wRkPcorU6DlrMMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteudu97VRzYD2A9vA7fIaYtdU8RQxkYx3Npct0T7YuU3IMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexmo5hwgOWl4z1OcLqRsZqFF4qjjQ6oI8YIlRQ6B5bUwcMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsh_45ZCuzYLyTEYCqOcdglr8JRrhCYL49z9GDXCizEzuz8Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsCNQgy_45q_45VhA5yzXoWLoXj3ANr1lWfRWTvovWmFNfRxkMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: edit5bnHwVu048ngKmuKsAy2kaNOpopgi61bynsTnsdCQ7wMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexi6nF1MLTXCc1aUE3URSYsviT03nRxkXbrTiO2SMr9LEMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsAk4_Nr9C236Hs5HlinVpIpipSmglesVzKvE2whQYcqsMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesrg6N_k_45txi8HbtdC8cLQCbG8K1VyeffQLSb7LaYCvlkMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editdnpW2JXIwDhexzkO7k4EjiTLoyVLwzyWjYAUFac2tDwMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexPuX5_45cBUFG7pxDyDXirU29WRiT_45VbGmEaEdSsp5EEroMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexqO_45aZJk26RbeIXrDdbqIYEfM6fWSGbmcr_45Uq7zkqdW4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45cles7Q2AA4poD81QKjRdpLzoIeGLUj_45leDaBe5ZM41XD0ekMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editSjHXkaFXydbV4XT4Dn2ss_e_MjMrSnwpeKiQ_45UgjHrEMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profileY_QI5kn0wi6N89OWjWkN8NHo3FRDVPnJKYanxBVaM6sMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsovaEi26zVqkHnacdJJ_0g6bmPKpDIbO9UfycK8knGPcMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: edit_6bde8p8Wjg2NTTzkN0DbGctX9XQU78uH_G8cvz_DykMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addzxzRSObHxj1ceQysOcSVH6NOdQVAHmO20oF_45OiIbxPwMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexEo0NniKKSKFld0n_rp1kSV2ZePiGfU5_lRvv4oFvgVQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: edit1EB7Z6p5BTcCMWMtpvTsx_nK9T9E59vkfnEeWYLznf0Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusions9GI1yjfSkEbE7f5hJ4EUbli3EWSXyzQ1c7WfWi13P_wMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsnHmZxN2CgtU3SGOej9ZBtIB9DYh7Md8qwvVR1nBJPIIMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingMtcO4tbemllD2AY0fRve6AVQOzDRxopCFxM796noPC8Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexPiiwsuQIMaUac7ygHmdTW8XNb7at2XSMhw_qaI83U_4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: edit_B8oTyQUMV_45JnnxjJkTUzn2FmgM_455cNmFvmTvwbq_9oMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexZ8HH5hwFB0lbT_45nnpSjq_45g3i8hRz9DipJ1Ot4l3cpF0Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileOvdXmhhQn6UzAJojThaIL99B9X4IXMI8b_ehIUDlQJAMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: index1KcOOE18lbPHzz7nu42GsJFKsxy3ItSnEYrOZvdjWnMMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: edit8pK0J5FaFoCQPEj75N9KPzKckEppL7oCkNLAydImj7MMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addCtgO_jmTZrADOS6viBZlCrenLbjgs5dwLJOLgmKOY0EMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesGzpsazCwLbbvHqaW2Gdb57oRmhxrzIxqdTXbnTrG8h4Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesl6_45_45IHN1bYIbKUg_45hxZE6UE_45__XW4FsfNzs_7IgjfaAMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45users1J88SWz19ZTnWvt4PsTcWjuTx1OUExmk4bbzGS3mnroMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresBK4yBt_45wSUHyjJVQHJhnlSp0Uw_SwS0jRFH4KGUA2uMMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisation00_PfnQPvRhBm9lwOsCc0Zk4ANQ7sisIGzigz_mPtNcMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedBvqKf4pXo1lgFe6g0DgExdsu2ZwgCraVN1EZzOrsWXIMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsJNtL4Yjehmu6Tkqx74Osa9sZtknew1rJ_kDGABr6mb0Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45role2eOafReBBVEh7afkb0a2keO2M4FqSAbNeOCPyC2iymUMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsHG17Z3zwN69vtHjDhfHx4V07vUOZG6z7qoPZ7gV2z84Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editWUsZ98m2KsB_454Tq8LHIslt_45gB5Te_45rv_ZN4N16vXSSwMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibiliteskhyZqJKwTH7OwbV_pPvhYJS_45kMWjLDK3VbuoIwksn68Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45link2RuhllH8K_45o74jTKipTdJpJ6cc6ExRrRgXjp6iAwRfQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexN_45c47_45c2GTqxnmVrK_Xyys3E9VTxcYK7Mur43StJAWgMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivite8nAFyfNkxX8fJorseN_D12fjeX5vz82S0Qz0wh5TlmkMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationQtmlIndEQnZH5qEFXCCYSVycypYPzziyugnvkIPnQLsMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationszqqCc6JhE7zD450pP_45qXfj9oZuJe6z2R9tDl_DYxenUMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantr4Q1LN7mh9PcRYBN7mm9UUpIiRqIW5UlVN0SPEDsn08Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantCSMxXaGx2G_XuFsvtbSRDt6bYae23CgW0rKDJMY36aEMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: index31Sc0_45cmJdhtWC7w82XUHUEgpRx6A03pBT_HMvAkmdsMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimees94sISIJOqOIW8dzxjS9YxPNAg30pyMJ8dbYeAJZlWMwMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerGoIpicD0xK6Kue7cE4DygRvEeTlce75noOHm7_IbSDcMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesOlyZjLhiE35hmfAooSbQE7BmNIjBeXnRo1cDKBqGwOQMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesvKH19X9ErKCK_45cQKAGd9l8pkBHKI4EvkIKaMgRdVkh8Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsXKGptq5V8a36P_45d_45X_45zBXFV6NlvuiNUu93cXeG6Py5UMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedOjt_FnqkVDewdbZyGtBn_4542aAt0b_45blX4Rqxh3oS3T8Meta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerZ5FkxV2jWclxCVAU6llJ2N7FASyDwoFMuU5TO0FQ5VoMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationHeUKyftz5VK_ypZwZAJAR6oiTCpNH1NWW1UkBoZcdcIMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationeLVGAXU1yfiYqKQQbkmbr94OyuQcuhRSlMeNE063gLUMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45valider_ETUwm8pGy02_LGgnJZeUOzmk2OgFKUBa1YWhQivt_QMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesePW8gsXxdEXe5FHkQXf3zfSfZ8JpNJDDaACPh4WT_aAMeta || {},
    component: () => import("/build/93859e61-d930-459f-b49a-be273e8bda22/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/user/settings",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/statistiques",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  },
  {
    name: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhYMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubjf7rTgjSCcVX5MVoUz5YocapvpL3yx7DzJHpfeHifhY
  }
]